import { render, staticRenderFns } from "./OfficeApp.vue?vue&type=template&id=b5a91d5a&scoped=true&"
import script from "./OfficeApp.vue?vue&type=script&lang=js&"
export * from "./OfficeApp.vue?vue&type=script&lang=js&"
import style0 from "./OfficeApp.vue?vue&type=style&index=0&id=b5a91d5a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5a91d5a",
  null
  
)

export default component.exports